module.exports = __webpack_public_path__ + "img/img_default02.ec1516e3.png";